query ReadBimClass(
    $revisionID: ID!
) {
    bimClassRevision(
        revisionID: $revisionID
    ) {
        id
        revisionID

        data {
            name(language: "en") {
                text
            }
        }

        metadata {
            createdAt
            deprecated
            tags
        }

        source
    }
}
